import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager';
import { GoodsPhoto } from '../../js/ComponentManager'
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from 'react-router-dom';
import "swiper/css";
import 'swiper/css/thumbs';

/* 개발담당:양유빈
 * 화면기능:메인 스와이퍼 상품
 * 세부설명:
*/

export class SwiperGoods extends Component {
    static displayName = SwiperGoods.name;

    constructor(props) {
        super(props);
        this.state = {
            ContentConmgr: { ...this.DataObject.ContentConmgr },
            GoodsList: [],
            Bgcolor: "",
        };
        this.handleGoodsDtl_Click = this.handleGoodsDtl_Click.bind(this);
        this.index = -1;
    }
    //초기화
    componentDidMount() {
        const ContentConmgr = Big3Common.Util.GetContentState(this.props, "data-info", null);
        this.index = Big3Common.Util.GetContentState(this.props, "index", -1);
        if (ContentConmgr !== null) {
            this.setState({ ContentConmgr: ContentConmgr }, () => {
                this.CallSwiperGoodsList();
            });
            
        }
    }
    DataObject = {
        ContentConmgr: {
            mgr_no: "",
            title: "",
            cntt_tye: "",
            fltr_tye:"",
            ui_tye: "",
            width_cnt: "",
            len_cnt: "",
            tab_use_yn: ""  //스와이프에서 탭은 미적용
        }
    }
    CallSwiperGoodsList = async () => {
        try {

            const Data = await Big3Common.Post(`api/AdMgr/HomeAd/GetMainSettingList`,
                {
                    mgr_no: this.state.ContentConmgr.mgr_no,
                    fltr_tye: this.state.ContentConmgr.fltr_tye
                }
            );
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const multiDataTable = JSON.parse(Data.multiDataTable);
                const GoodsList = multiDataTable.goodsList;
                const Bgcolor = multiDataTable.bgcolor;
                this.setState({
                    GoodsList: GoodsList,
                    Bgcolor: Bgcolor
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("componentDidMount", e);
        }
    }
    handleGoodsDtl_Click = async (event, goods_no, uid) => {
        const GoodsDtlShow = this.props.GoodsDtlShow;
        const mgr_no = this.state.ContentConmgr.mgr_no;
        if (GoodsDtlShow !== undefined && GoodsDtlShow !== null) {
            GoodsDtlShow(goods_no, uid, mgr_no);
        }
        event.preventDefault();
    }
    GoodsBoxrender(GoodsList) {
        const SlidersCount = Big3Common.WebConfig.SlidersCount;
        return (
            <Swiper watchSlidesProgress={true} slidesPerView={SlidersCount} className="recent_poroducts row row-cols-3 no_line">
                <div>
                    {
                        GoodsList.map((list, idx) =>
                            <SwiperSlide key={`${list.mgr_no}_${idx}_${list.uid}_${list.goods_no}`} className="product"
                                onClick={(e) => { this.handleGoodsDtl_Click(e, list.goods_no, list.uid) }}
                            >
                                <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                    Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                                    BackGround={true}
                                    SimilarityYn="Y"
                                />
                                <div className="shop_name">{list.whole_name}</div>
                                <div className="product_name">{list.goods_nm}</div>
                                <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                                {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                            </SwiperSlide>
                        )}
                </div>
                <SwiperSlide>
                    {/* 공백*/}
                </SwiperSlide>
            </Swiper>
        )
    }
    render() {
        const GoodsList = this.state.GoodsList;
        const LintAdress = `/AdMgr/ListGoodsMore?mgr_no=${this.state.ContentConmgr.mgr_no}`;
        if (GoodsList.length === 0) {
            return
        }
        else {
            const Css = `main_content ${this.state.Bgcolor}`
            return (
                <div className={Css } key={`${this.state.ContentConmgr.mgr_no}_${this.index}`}>
                    <div className="rt_main_title_box">
                        <div className="title2">{Big3Common.Util.GetContentState(this.state.ContentConmgr, "title", "")}</div>
                        <Link to={LintAdress} >
                            <div className="more_view">더보기</div>
                        </Link>
                    </div>
                    <div className="today_poroducts row row-cols-3 ">
                        {this.GoodsBoxrender(GoodsList)}
                    </div>
                </div>
            );
        }        
    }
}
